module.exports = __webpack_public_path__ + "img/entrp.5052b0b3.svg";